export default __webpack_public_path__ + "static/media/approve.d13a8248.svg";